import React from 'react';
import { Helmet } from 'react-helmet';

import { APP_DESCRIPTION, APP_NAME } from '../constants';

const HeadComponent = ({ title, description }) => (
    <Helmet>
        <title>{`${APP_NAME} - ${title}`}</title>
        <meta name="description" content={description ? description : APP_DESCRIPTION} />
    </Helmet>
);

export default HeadComponent;



// WEBPACK FOOTER //
// ./src/components/HeadComponent.js